import React from 'react'

import { BlockContainer } from 'common/builder/components/chart/FlowChart/components/BlockContainer/BlockContainer'

import { BlockMapping } from './blockMapping'
import { FallbackGenericBlock } from './generic/Fallback/Fallback'
import { BlockComponent } from './types'

export const Block: BlockComponent = (props) => {
  const BlockComponent = BlockMapping[props.block.type] || FallbackGenericBlock
  return (
    <BlockContainer isLast={props.isLast}>
      <BlockComponent {...props} />
    </BlockContainer>
  )
}
